(function(){'use strict';
var L=window.PZSE, $=L.$, $all=L.$all, CANVAS_PX=L.CANVAS_PX, WORK_LONG=L.WORK_LONG, distanceOutside=L.distanceOutside, fillHoles=L.fillHoles, countComponents=L.countComponents, maskToCanvas=L.maskToCanvas, SHAPES=L.SHAPES;
var Editor=L.Editor;
Editor.prototype.contourMask = function (borderPxRatio, bigPad) {
var key = 'c' + borderPxRatio.toFixed(4) + (this.art.canvas.width) + 'x' + this.art.canvas.height;
if (this.cache[key]) return this.cache[key];
var aw = this.art.canvas.width, ah = this.art.canvas.height;
var s = WORK_LONG / Math.max(aw, ah);
var w0 = Math.max(1, Math.round(aw * s)), h0 = Math.max(1, Math.round(ah * s));
var bpx = borderPxRatio * WORK_LONG;
var pad = Math.ceil(bpx + 4 + (bigPad ? 115 : 0));
var W = w0 + pad * 2, H = h0 + pad * 2;
var c = document.createElement('canvas'); c.width = W; c.height = H;
var g = c.getContext('2d', { willReadFrequently: true });
g.drawImage(this.art.canvas, pad, pad, w0, h0);
var px = g.getImageData(0, 0, W, H).data;
var mask = new Uint8Array(W * H);
var opaque = !this.art.hasAlpha;
for (var i = 0; i < W * H; i++) mask[i] = (opaque ? (px[i * 4 + 3] > 0) : (px[i * 4 + 3] > 90)) ? 1 : 0;
var dist = distanceOutside(mask, W, H);
var region = new Uint8Array(W * H);
var thr = Math.max(bpx, 0.5);
for (var j = 0; j < W * H; j++) region[j] = dist[j] <= thr ? 1 : 0;
fillHoles(region, W, H);
if (countComponents(region, W, H) > 1) {
if (!bigPad) return this.contourMask(borderPxRatio, true);
var steps = [8, 16, 28, 45, 70, 110];
for (var si = 0; si < steps.length; si++) {
var cc = steps[si];
var grown = new Uint8Array(W * H);
for (var k = 0; k < W * H; k++) grown[k] = dist[k] <= thr + cc ? 1 : 0;
fillHoles(grown, W, H);
var inv = new Uint8Array(W * H);
for (var k2 = 0; k2 < W * H; k2++) inv[k2] = grown[k2] ? 0 : 1;
var dIn = distanceOutside(inv, W, H);
var closed = new Uint8Array(W * H);
for (var k3 = 0; k3 < W * H; k3++) closed[k3] = (grown[k3] && dIn[k3] > cc) || region[k3] ? 1 : 0;
fillHoles(closed, W, H);
if (countComponents(closed, W, H) === 1) { region = closed; break; }
if (si === steps.length - 1) region = closed;
}
}
var minX = W, minY = H, maxX = -1, maxY = -1;
for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) if (region[y * W + x]) {
if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y;
}
var res = { region: maskToCanvas(region, W, H, [255, 255, 255, 255]), W: W, H: H, pad: pad, w0: w0, h0: h0, bbox: { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 } };
this.cache[key] = res;
return res;
};
Editor.prototype.workspace=function(maxIn){
var ws=Math.max(4,maxIn*1.3), steps=[1,2,3,6,12,24,36,48];
var step=steps.filter(function(s){ return ws/s<=9; })[0]||48;
ws=Math.ceil(ws/step)*step;
return { ws:ws, step:step, ppi:CANVAS_PX/ws, ft:ws>48 };
};
Editor.prototype.drawGrid=function(g,W){
var key=W.ws+'|'+W.step;
if(!this._grid||this._gridKey!==key){
var gc=document.createElement('canvas'); gc.width=CANVAS_PX; gc.height=CANVAS_PX; var t=gc.getContext('2d');
t.fillStyle='#f4f4f4'; t.fillRect(0,0,CANVAS_PX,CANVAS_PX);
var minor=W.step/4, n=Math.round(W.ws/minor);
for(var i=0;i<=n;i++){
var p=Math.round(i*minor*W.ppi)+0.5, major=i%4===0, half=i%2===0;
t.strokeStyle=major?'#c9c9c9':half?'#dddddd':'#ebebeb'; t.lineWidth=major?2:1;
t.beginPath(); t.moveTo(p,0); t.lineTo(p,CANVAS_PX); t.stroke();
t.beginPath(); t.moveTo(0,p); t.lineTo(CANVAS_PX,p); t.stroke();
}
t.fillStyle='#9a9a9a'; t.font='22px Arial, sans-serif'; t.textBaseline='top';
for(var k=W.step;k<W.ws;k+=W.step){ var lab=W.ft&&k%12===0?(k/12)+' ft':k+'″'; t.fillText(lab,k*W.ppi+6,6); t.fillText(lab,6,k*W.ppi+6); }
this._grid=gc; this._gridKey=key;
}
g.drawImage(this._grid,0,0);
};
function shapePath(g,shape,x,y,w,h){
g.beginPath();
if(shape==='circle'||shape==='oval') g.ellipse(x+w/2,y+h/2,w/2,h/2,0,0,Math.PI*2);
else if(shape==='rounded'){ var r=Math.min(w,h)*0.16; if(g.roundRect) g.roundRect(x,y,w,h,r); else g.rect(x,y,w,h); }
else g.rect(x,y,w,h);
}
L.shapePath=shapePath;
Editor.prototype.cutValue=function(o){
if(this.cfg.cutChips===false){ var k=Object.keys(o).filter(function(n){ return /^cut$/i.test(n); })[0]; return k?o[k]:'Die cut'; }
return this.state.cut;
};
Editor.prototype.render=function(){
if(!this.ctx||!this.art) return;
if(!document.body.contains(this.preview)){ var media=$('.product__media-wrapper'); if(media) media.insertBefore(this.preview,media.firstChild); }
var c=this.cfg, st=this.state, D=this.dims(), FX=L.fx, g=this.ctx;
var mat=FX?FX.material(c):'matte', light=this.light||this.autoLight||null; this.mat=mat;
if(c.mode==='flat') return this.renderFlat(D,mat,light);
var S=Math.max(D.w,D.h), W=this.workspace(S), PPI=W.ppi, b=st.border;
this.drawGrid(g,W);
var aw=this.art.canvas.width, ah=this.art.canvas.height, aspect=ah/aw, cx=CANVAS_PX/2, cy=CANVAS_PX/2;
var sw,sh,body=FX?FX.canvas():null, bg=body&&body.getContext('2d'), drawArt, drawLine, self=this;
if(st.shape==='contour'){
var artLong=Math.max(S*0.1,S-2*b), m=this.contourMask(b/artLong);
var k=(artLong*PPI)/WORK_LONG; k*=(S*PPI)/(Math.max(m.bbox.w,m.bbox.h)*k);
sw=m.bbox.w*k; sh=m.bbox.h*k;
var ox=cx-(m.bbox.x+m.bbox.w/2)*k, oy=cy-(m.bbox.y+m.bbox.h/2)*k, RW=m.W*k, RH=m.H*k;
if(bg){ bg.imageSmoothingEnabled=true; bg.imageSmoothingQuality='high'; bg.drawImage(m.region,ox,oy,RW,RH); }
drawArt=function(){ var ax=ox+m.pad*k, ay=oy+m.pad*k, w=m.w0*k, h=m.h0*k; if(FX&&FX.art) FX.art(g,self.art.canvas,ax,ay,w,h,c,light); else g.drawImage(self.art.canvas,ax,ay,w,h); };
drawLine=function(){ var key=[ox,oy,RW,RH].map(function(v){ return Math.round(v*10); }).join(','); if(!self._line||self._lineKey!==key||self._lineM!==m){ self._lineM=m; self._lineKey=key; self._line=self.drawCutLine(m.region,ox,oy,RW,RH); } g.drawImage(self._line,0,0); };
} else {
var w,h;
if(st.shape==='circle'||st.shape==='square'||st.shape==='rounded'){ w=h=S; }
else { var asp=Math.min(1,Math.max(0.35,aspect<1?aspect:1/aspect)); if(aspect<=1){ w=S; h=S*asp; } else { h=S; w=S*asp; } }
sw=w*PPI; sh=h*PPI; var x=cx-sw/2, y=cy-sh/2;
if(bg){ bg.fillStyle='#fff'; shapePath(bg,st.shape,x,y,sw,sh); bg.fill(); }
drawArt=function(){ g.save(); shapePath(g,st.shape,x,y,sw,sh); g.clip(); var bw=sw-b*PPI*2, bh=sh-b*PPI*2; if(st.shape==='circle'||st.shape==='oval'){ bw*=0.86; bh*=0.86; } if(bw>2&&bh>2){ var s2=Math.min(bw/aw,bh/ah), w2=aw*s2, h2=ah*s2; if(FX&&FX.art) FX.art(g,self.art.canvas,cx-w2/2,cy-h2/2,w2,h2,c,light); else g.drawImage(self.art.canvas,cx-w2/2,cy-h2/2,w2,h2); } g.restore(); };
drawLine=function(){ g.save(); g.setLineDash([10,7]); g.lineWidth=3; g.strokeStyle='#e6007e'; shapePath(g,st.shape,x,y,sw,sh); g.stroke(); g.restore(); };
}
var cut=this.cutValue(D.opts);
if(/kiss/i.test(cut)){ var mrg=0.125*PPI*(S/3>1?Math.min(S/3,4):1), kw=sw+mrg*2, kh=sh+mrg*2; g.save(); g.shadowColor='rgba(0,0,0,.18)'; g.shadowBlur=10; g.shadowOffsetY=3; g.fillStyle=mat==='clear'?'rgba(250,250,250,.55)':'#fbfbfb'; if(g.roundRect){ g.beginPath(); g.roundRect(cx-kw/2,cy-kh/2,kw,kh,10); g.fill(); } else g.fillRect(cx-kw/2,cy-kh/2,kw,kh); g.restore(); }
if(FX) FX.base(g,body,mat,light);
drawArt();
if(FX) FX.finish(g,body,mat,light);
drawLine();
this.dimsText=(sw/PPI).toFixed(2)+'″ × '+(sh/PPI).toFixed(2)+'″';
if(this.dimEl) this.dimEl.textContent=(st.shape==='contour'?'Custom cut':SHAPES.filter(function(s){ return s.id===st.shape; })[0].label)+' · '+this.dimsText+(FX&&c.fx!=='none'?' · '+FX.labels[mat]:'')+(/kiss/i.test(cut)?' · kiss cut':'');
this.writeProps();
};
Editor.prototype.drawCutLine=function(region,x,y,w,h){
var c=document.createElement('canvas'); c.width=CANVAS_PX; c.height=CANVAS_PX; var t=c.getContext('2d'), lw=3;
t.imageSmoothingEnabled=true;
for(var a=0;a<16;a++){ var an=a*Math.PI/8; t.drawImage(region,x+Math.cos(an)*lw,y+Math.sin(an)*lw,w,h); }
t.globalCompositeOperation='source-in'; t.fillStyle='#e6007e'; t.fillRect(0,0,CANVAS_PX,CANVAS_PX);
t.globalCompositeOperation='destination-out'; t.drawImage(region,x,y,w,h);
return c;
};
Editor.prototype.bindLight=function(){
var self=this, cv=this.canvas, raf=0, hover=false;
function req(){ if(!raf) raf=requestAnimationFrame(function(){ raf=0; self.render(); }); }
cv.addEventListener('pointermove',function(e){ var r=cv.getBoundingClientRect(); self.light={x:(e.clientX-r.left)/r.width,y:(e.clientY-r.top)/r.height}; hover=true; if(L.fx&&L.fx.animated(self.mat)) req(); });
cv.addEventListener('pointerleave',function(){ hover=false; self.light=null; req(); });
var visible=true; if(window.IntersectionObserver) new IntersectionObserver(function(en){ visible=en[0].isIntersecting; }).observe(cv);
var t0=Date.now();
setInterval(function(){
if(hover||!visible||document.hidden||!L.fx) return;
if(self.mat!=='holo'&&self.mat!=='glitter'){ if(self.autoLight){ self.autoLight=null; req(); } return; }
var t=(Date.now()-t0)/1000; self.autoLight={x:.5+Math.sin(t*.9)*.35,y:.5+Math.cos(t*.6)*.25}; req();
},90);
};
})();